import { ValueFormatterParams } from '@ag-grid-community/core'
import { ECOM_PRICING_FORM_FIELDS } from 'utils/constants'
import { convertTo12HourFormat, formatDate } from 'utils/helpers'

const {
  BARCODE,
  BASE_PRICE,
  CLUSTER,
  SPECIAL_PRICE,
  SPECIAL_PRICE_END_DATE,
  SPECIAL_PRICE_START_DATE,
  CREATED_AT,
  UPDATED_AT,
} = ECOM_PRICING_FORM_FIELDS

export const columns = [
  {
    headerName: BARCODE.label,
    field: BARCODE.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: BASE_PRICE.label,
    field: BASE_PRICE.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: CLUSTER.label,
    field: CLUSTER.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: SPECIAL_PRICE.label,
    field: SPECIAL_PRICE.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: SPECIAL_PRICE_START_DATE.label,
    field: SPECIAL_PRICE_START_DATE.key,
    valueFormatter: (params: ValueFormatterParams) =>
      params.value ? formatDate(params.value) : '-',
  },
  {
    headerName: SPECIAL_PRICE_END_DATE.label,
    field: SPECIAL_PRICE_END_DATE.key,
    valueFormatter: (params: ValueFormatterParams) =>
      params.value ? formatDate(params.value) : '-',
  },
  {
    headerName: CREATED_AT.label,
    field: CREATED_AT.key,
    valueFormatter: (params: ValueFormatterParams) =>
      params.value ? convertTo12HourFormat(params.value) : '-',
  },
  {
    headerName: UPDATED_AT.label,
    field: UPDATED_AT.key,
    valueFormatter: (params: ValueFormatterParams) =>
      params.value ? convertTo12HourFormat(params.value) : '-',
  },
]
